import { launchDeposit, launchRegister } from '../../../model/actions';
import { DynamicRouteActionTypesEnum, LogicContext } from '../types';

const routeDynamicActionMap = {
  [DynamicRouteActionTypesEnum.OPEN_REGISTRATION_MODAL]: launchRegister,
  [DynamicRouteActionTypesEnum.OPEN_DEPOSIT_MODAL]: launchDeposit,
};

export const performRouteDynamicAction = (context: LogicContext) => {
  const routeDynamicAction = context?.routeDynamicAction;
  if (!routeDynamicAction) {
    return;
  }

  const action = routeDynamicActionMap[routeDynamicAction];
  return !!action && action();
};
